// extracted by mini-css-extract-plugin
export default {"imageContainer":"NewExpense_imageContainer__j0WP-"};